export const LOGIN_PROMPT_CLOSE_TIME_KEY = 'nicom/catalog/login-prompt-closed';
export const LOGIN_PROMPT_HIDE_HOURS = 72;
